import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElementOutline = _resolveComponent("ElementOutline")!
  const _component_ProsemirrorEditor = _resolveComponent("ProsemirrorEditor")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-text", { 'lock': _ctx.elementInfo.lock }]),
    ref: "elementRef",
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "element-content",
        style: _normalizeStyle({
          backgroundColor: _ctx.elementInfo.fill,
          opacity: _ctx.elementInfo.opacity,
          textShadow: _ctx.shadowStyle,
          lineHeight: _ctx.elementInfo.lineHeight,
          letterSpacing: (_ctx.elementInfo.wordSpace || 0) + 'px',
          color: _ctx.elementInfo.defaultColor,
          fontFamily: _ctx.elementInfo.defaultFontName,
        }),
        onMousedown: _cache[3] || (_cache[3] = $event => _ctx.handleSelectElement($event))
      }, [
        _createVNode(_component_ElementOutline, {
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height,
          outline: _ctx.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createVNode(_component_ProsemirrorEditor, {
          class: "text",
          elementId: _ctx.elementInfo.id,
          defaultColor: _ctx.elementInfo.defaultColor,
          defaultFontName: _ctx.elementInfo.defaultFontName,
          editable: !_ctx.elementInfo.lock,
          value: _ctx.elementInfo.content,
          style: _normalizeStyle({
            '--textIndent': `${_ctx.elementInfo.textIndent || 0}px`,
            '--paragraphSpace': `${_ctx.elementInfo.paragraphSpace === undefined ? 5 : _ctx.elementInfo.paragraphSpace}px`,
          }),
          onUpdate: _cache[0] || (_cache[0] = value => _ctx.updateContent(value)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkEmptyText())),
          onMousedown: _cache[2] || (_cache[2] = $event => _ctx.handleSelectElement($event, false))
        }, null, 8, ["elementId", "defaultColor", "defaultFontName", "editable", "value", "style"]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "drag-handler top" }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "drag-handler bottom" }, null, -1))
      ], 36)), [
        [_directive_contextmenu, _ctx.contextmenus]
      ])
    ], 4)
  ], 6))
}